<template><BusinessPage module-key="operationLogs" /></template>
<script>import BusinessPage from '../common/BusinessPage.vue'; export default { name: 'OperationLogsPage', components: { BusinessPage } }</script>
